// extracted by mini-css-extract-plugin
module.exports = {"agent-list-container":"AgentListViewMobile_agent-list-container__1nj6R","empty-msg":"AgentListViewMobile_empty-msg__48YTd","msg":"AgentListViewMobile_msg__2lY57"};